import { render, staticRenderFns } from "./HasProfessionalIntervenedQuestion.vue?vue&type=template&id=00837c40&scoped=true"
import script from "./HasProfessionalIntervenedQuestion.vue?vue&type=script&lang=ts"
export * from "./HasProfessionalIntervenedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00837c40",
  null
  
)

export default component.exports